import {
  projectDescriptionChanged,
  selectedChatbotChanged,
  selectedFiltersChanged,
  selectedJurisdictionChanged,
  selectedTrendAnalysisChanged,
  selectedExportToggleChanged,
  selectedBenefitsChanged,
  selectedWorkforcesChanged,
  selectedDataAggregationChanged,
  selectedUseCasesChanged,
  selectedPOIChanged,
  selectedPersonaChanged
} from './CompareChanges'

export const checkDetailsUpdated = (setShowPopupOnNav, projectChanges) => {
  const {
    projectDescription,
    currentDescription,
    selectedJurisdiction,
    currentJurisdiction,
    selectedDataAggregation,
    currentDataAggregation,
    selectedFilters,
    currentFilters,
    selectedUseCases,
    currentUseCases,
    selectedBenefits,
    currentBenefits,
    selectedWorkforces,
    currentWorkforces,
    currentGroupName,
    projectName,
    selectedTrendAnalysis,
    trendAnalysisFlag,
    selectedChatbot,
    chatbotFlag,
    selectedExportToggle,
    exportFlag,
    selectedPOI,
    currentPOI,
    selectedPersona,
    personaFlag
  } = projectChanges
  currentGroupName !== projectName ||
  projectDescriptionChanged(projectDescription, currentDescription) ||
  selectedFiltersChanged(selectedFilters, currentFilters) ||
  selectedUseCasesChanged(selectedUseCases, currentUseCases) ||
  selectedDataAggregationChanged(selectedDataAggregation, currentDataAggregation) ||
  selectedBenefitsChanged(selectedBenefits, currentBenefits) ||
  selectedWorkforcesChanged(selectedWorkforces, currentWorkforces) ||
  selectedJurisdictionChanged(selectedJurisdiction, currentJurisdiction) ||
  selectedTrendAnalysisChanged(selectedTrendAnalysis, trendAnalysisFlag) ||
  selectedPOIChanged(selectedPOI, currentPOI) ||
  selectedChatbotChanged(selectedChatbot, chatbotFlag) ||
  selectedPersonaChanged(selectedPersona, personaFlag) ||
  selectedExportToggleChanged(selectedExportToggle, exportFlag)
    ? setShowPopupOnNav?.(true)
    : setShowPopupOnNav?.(false)
}
